import _ from 'lodash'
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { axiosCall } from '../modules/apiCall';
import { StoreAction, Lang } from '../types';

import {
    setIsLoading,
    getNameStatisticGeneralInfo,
    setNameStatisticGeneralInfo,
    getSearchNameInfo,
    setSearchNameInfo,
    getTop10NamesByYearInfo,
    setTop10NamesByYearInfo,
    getTop10NameWordsByYearInfo,
    setTop10NameWordsByYearInfo,
    getTop5NewBornNameWordsByYearInfo,
    setTop5NewBornNameWordsByYearInfo
} from '../slices/storeSlice';

let GetNameStatisticGeneralInfoLink = '';
let SearchNameLink = '';
let GetTop10NamesByYearInfoLink = '';
let GetTop10NameWordsByYearInfoLink = '';
let GetTop5NewBornNameWordsByYearInfoLink='';

if (process.env.NODE_ENV == 'production') {
    GetNameStatisticGeneralInfoLink = `https://www.dsec.gov.mo/${process.env.PUBLIC_URL}/GetNameStatisticGeneralInfoJSON`;
    SearchNameLink = `https://www.dsec.gov.mo/${process.env.PUBLIC_URL}/SearchName`;
    GetTop10NamesByYearInfoLink = `https://www.dsec.gov.mo/${process.env.PUBLIC_URL}/GetTop10NamesByYear`;
    GetTop10NameWordsByYearInfoLink =`https://www.dsec.gov.mo/${process.env.PUBLIC_URL}/GetTop10NameWordsByYear`;
    GetTop5NewBornNameWordsByYearInfoLink=`https://www.dsec.gov.mo/${process.env.PUBLIC_URL}/GetTop5NewBornNameWordsByYear`;
}else{
    let devUrl = "http://10.207.0.99:3400";
    // let devUrl = "https://www.dsec.gov.mo";
    let domain = 'NameStatistic'
    GetNameStatisticGeneralInfoLink = `${devUrl}/${domain}/GetNameStatisticGeneralInfoJSON`;
    SearchNameLink = `${devUrl}/${domain}/SearchName`;
    GetTop10NamesByYearInfoLink = `${devUrl}/${domain}/GetTop10NamesByYear`;
    GetTop10NameWordsByYearInfoLink =`${devUrl}/${domain}/GetTop10NameWordsByYear`;
    GetTop5NewBornNameWordsByYearInfoLink=`${devUrl}/${domain}/GetTop5NewBornNameWordsByYear`;
}

export function* getNameStatisticGeneralInfoFunc() {
    let url = GetNameStatisticGeneralInfoLink;

    try {
        yield put(setIsLoading(true));
        let value: any;
        ({ value } = yield call(
            axiosCall,
            url,
            'GET'
        ));

        yield put(setIsLoading(false));
        yield put(setNameStatisticGeneralInfo(value));
    } catch (err) {
        console.log(err);
    }
};

export function* getSearchNameFunc({ payload }: StoreAction<any>) {
    const { year, familyName, name } = payload!;

    let url = SearchNameLink;

    try {
        yield put(setSearchNameInfo(null));
        yield put(setIsLoading(true));
        let value: any;
        ({ value } = yield call(
            axiosCall,
            url,
            'POST',
            { year: year, familyName: familyName||"", name: name||"" }
        ));

        yield put(setIsLoading(false));
        yield put(setSearchNameInfo(value));
    } catch (err) {
        console.log(err);
    }
};

export function* getTop10NamesByYearInfoFunc({ payload }: StoreAction<any>) {
    const {year} = payload!;

    let url = GetTop10NamesByYearInfoLink;

    try {
        yield put(setIsLoading(true));
        let value: any;
        ({ value } = yield call(
            axiosCall,
            url,
            'POST',
            { year: year}
        ));

        yield put(setIsLoading(false));
        yield put(setTop10NamesByYearInfo(value));
    } catch (err) {
        console.log(err);
    }
};

export function* getTop10NameWordsByYearInfoFunc({ payload }: StoreAction<any>) {
    const {year} = payload!;

    let url = GetTop10NameWordsByYearInfoLink;

    try {
        yield put(setIsLoading(true));
        let value: any;
        ({ value } = yield call(
            axiosCall,
            url,
            'POST',
            { year: year}
        ));

        yield put(setIsLoading(false));
        yield put(setTop10NameWordsByYearInfo(value));
    } catch (err) {
        console.log(err);
    }
};

export function* getTop5NewBornNameWordsByYearInfoFunc({ payload }: StoreAction<any>) {
    const {year} = payload!;

    let url = GetTop5NewBornNameWordsByYearInfoLink;

    try {
        yield put(setIsLoading(true));
        let value: any;
        ({ value } = yield call(
            axiosCall,
            url,
            'POST',
            { year: year}
        ));

        yield put(setIsLoading(false));
        yield put(setTop5NewBornNameWordsByYearInfo(value));
    } catch (err) {
        console.log(err);
    }
};

/**
 * Indicator Sagas
 */
export default function* root() {
    yield all([takeLatest(getNameStatisticGeneralInfo.type, getNameStatisticGeneralInfoFunc)]);
    yield all([takeLatest(getSearchNameInfo.type, getSearchNameFunc)]);
    yield all([takeLatest(getTop10NamesByYearInfo.type, getTop10NamesByYearInfoFunc)]);
    yield all([takeLatest(getTop10NameWordsByYearInfo.type, getTop10NameWordsByYearInfoFunc)]);
    yield all([takeLatest(getTop5NewBornNameWordsByYearInfo.type, getTop5NewBornNameWordsByYearInfoFunc)]);
}

